// Display mirror of backend/src/lib/recommendationTasks.ts: how a recommended action is recognised,
// so the insights panel can tell one already raised as a corrective action. Kept identical by
// backend/src/lib/__tests__/recommendationTasks.test.ts. The server decides; this only labels.

/** The wording a recommendation is recognised by: case, spacing and trailing punctuation do not matter. */
export function normaliseRecommendation(text: string): string {
  return text.toLowerCase().replace(/\s+/g, " ").trim().replace(/[.;:,\s]+$/, "");
}

/** A short stable key for one recommendation's wording (two FNV-1a 32-bit hashes, 16 hex). */
export function recommendationKey(text: string): string {
  const s = normaliseRecommendation(text);
  let a = 0x811c9dc5;
  let b = 0x01000193 ^ 0x5bd1e995;
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    a = Math.imul(a ^ c, 0x01000193) >>> 0;
    b = Math.imul(b ^ c, 0x01000193) >>> 0;
    b = (b ^ (b >>> 13)) >>> 0;
  }
  return a.toString(16).padStart(8, "0") + b.toString(16).padStart(8, "0");
}

/** One implementation step with the people it names, each matched to a member only by exact name or email. */
export interface StepDetail { text: string; people: Array<{ name: string; userId: string | null }> }

/** An action already raised from one of this control's recommendations (GET /improvement/recommendation-actions). */
export interface RaisedRecommendation { key: string; id: string; displayId: number | null; status: string; steps: number; stepsDone: number }
